import { render, staticRenderFns } from "./choisePosition.vue?vue&type=template&id=8f634b18&scoped=true"
import script from "./choisePosition.vue?vue&type=script&lang=js"
export * from "./choisePosition.vue?vue&type=script&lang=js"
import style0 from "./choisePosition.vue?vue&type=style&index=0&id=8f634b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f634b18",
  null
  
)

export default component.exports